import { z } from 'zod'

export const messageCategorySchema = z.object({
  id: z.number(),
  nameFi: z.string(),
  nameSv: z.string(),
  nameEn: z.string(),
})

const fileSchema = z.object({
  name: z.string(),
  url: z.string(),
})

const outgoingEmailMessageSchema = z.object({
  __typename: z.literal('OutgoingEmailMessage'),
  messageId: z.number(),
  timestamp: z.string(),
  title: z.string(),
  htmlContent: z.string(),
  isRead: z.boolean(),
  isMass: z.boolean(),
  isAutomatic: z.boolean(),
  files: z.array(fileSchema).nullable().optional(),
})

const incomingEmailMessageSchema = z.object({
  __typename: z.literal('IncomingEmailMessage'),
  messageId: z.number(),
  timestamp: z.string(),
  title: z.string(),
  htmlContent: z.string(),
  senderName: z.string().nullable(),
  files: z.array(fileSchema).nullable().optional(),
})

const manualEmailConversationSchema = z.object({
  __typename: z.literal('ManualEmailConversation'),
  messageId: z.number(),
  timestamp: z.string(),
  title: z.string(),
  htmlContent: z.string(),
  files: z.array(fileSchema).nullable().optional(),
})

const messageEntrySchema = z.discriminatedUnion('__typename', [
  outgoingEmailMessageSchema,
  incomingEmailMessageSchema,
  manualEmailConversationSchema,
])

export const messageThreadSchema = z.object({
  __typename: z.literal('MessageThread'),
  id: z.string(),
  canReply: z.boolean(),
  // Optional because only the single thread endpoint returns these fields,
  // the timeline endpoint does not.
  messageCategory: messageCategorySchema.nullable().optional(),
  isReplyVisibleToOtherParticipants: z.boolean().optional(),
  entries: z.array(messageEntrySchema),
})

export type MessageThread = z.infer<typeof messageThreadSchema>

export const residentMessageCategoriesSchema = z.object({
  categories: z.array(messageCategorySchema),
})

export type MessageCategory = z.infer<typeof messageCategorySchema>

export const residentMessageTimelineSchema = z.object({
  messages: z.array(messageThreadSchema),
})
